"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AmmParser = exports.AMM_LAYOUT_V4 = void 0;
const BufferLayout = __importStar(require("buffer-layout"));
const Layout = __importStar(require("../../../utils/layout"));
exports.AMM_LAYOUT_V4 = BufferLayout.struct([
    Layout.uint64('status'),
    Layout.uint64('nonce'),
    Layout.uint64('orderNum'),
    Layout.uint64('depth'),
    Layout.uint64('coinDecimals'),
    Layout.uint64('pcDecimals'),
    Layout.uint64('state'),
    Layout.uint64('resetFlag'),
    Layout.uint64('minSize'),
    Layout.uint64('volMaxCutRatio'),
    Layout.uint64('amountWaveRatio'),
    Layout.uint64('coinLotSize'),
    Layout.uint64('pcLotSize'),
    Layout.uint64('minPriceMultiplier'),
    Layout.uint64('maxPriceMultiplier'),
    Layout.uint64('systemDecimalsValue'),
    // Fees
    Layout.uint64('minSeparateNumerator'),
    Layout.uint64('minSeparateDenominator'),
    Layout.uint64('tradeFeeNumerator'),
    Layout.uint64('tradeFeeDenominator'),
    Layout.uint64('pnlNumerator'),
    Layout.uint64('pnlDenominator'),
    Layout.uint64('swapFeeNumerator'),
    Layout.uint64('swapFeeDenominator'),
    // OutPutData
    Layout.uint64('needTakePnlCoin'),
    Layout.uint64('needTakePnlPc'),
    Layout.uint64('totalPnlPc'),
    Layout.uint64('totalPnlCoin'),
    Layout.uint128('poolTotalDepositPc'),
    Layout.uint128('poolTotalDepositCoin'),
    Layout.uint128('swapCoinInAmount'),
    Layout.uint128('swapPcOutAmount'),
    Layout.uint64('swapCoin2PcFee'),
    Layout.uint128('swapPcInAmount'),
    Layout.uint128('swapCoinOutAmount'),
    Layout.uint64('swapPc2CoinFee'),
    Layout.publicKey('poolCoinTokenAccount'),
    Layout.publicKey('poolPcTokenAccount'),
    Layout.publicKey('coinMintAddress'),
    Layout.publicKey('pcMintAddress'),
    Layout.publicKey('lpMintAddress'),
    Layout.publicKey('ammOpenOrders'),
    Layout.publicKey('serumMarket'),
    Layout.publicKey('serumProgramId'),
    Layout.publicKey('ammTargetOrders'),
    Layout.publicKey('poolWithdrawQueue'),
    Layout.publicKey('poolTempLpTokenAccount'),
    Layout.publicKey('ammOwner'),
    Layout.publicKey('pnlOwner')
]);
const AmmParser = (pubkey, info) => {
    if (info == null) {
        throw new Error("");
    }
    const buffer = Buffer.from(info.data);
    const reserve = exports.AMM_LAYOUT_V4.decode(buffer);
    const details = {
        pubkey,
        account: Object.assign({}, info),
        info: reserve,
    };
    return details;
};
exports.AmmParser = AmmParser;
